import React from "react";
import "../../landing.css";
import localeText from "../../../../locale";

const LandingTransitionBar = ({ title, text, anchor }) => {
  return (
    <div className="full-width bg-white" style={{ borderBottom: "1px solid var(--extra-line)" }}>
      <div className="flex flex-wrap align-items-center justify-content-between gap-3 py-4">
        <div>
          <div className="font-bold text-lg title" style={{ color: "var(--extra-green)" }}>
            {title}
          </div>
          <div className="text-sm mt-1" style={{ color: "var(--extra-body)" }}>
            {text}
          </div>
        </div>
        <a
          href={anchor}
          className="flex align-items-center gap-2 text-sm font-bold no-underline white-space-nowrap"
          style={{ color: "var(--extra-green)" }}
        >
          {localeText("lp2ContinueExploring")} <i className="pi pi-arrow-down text-xs"></i>
        </a>
      </div>
    </div>
  );
};

export default LandingTransitionBar;
